/**
 * @component Case
 * @since 1.0.0
 */
export function Case(props) {
    return props.is ? props.children : null;
}
